export const STATUS_SUCCESS = 0;
export const STATUS_NORMAL_ERROR = -1;
export const STATUS_NEED_LOGIN = -2;
